var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bookingTypeId)?_c('div',[(_vm.permanentBlock)?_c('div',[_vm._v("ブロック予約のため非表示")]):(_vm.bookingTypeId === 12)?_c('ListPointTieUp'):_c('ListBillingStatement')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }